import React from 'react';

import {DEFAULT_BRANDING, DEFAULT_PALETTE} from '../styles';
import * as S from './style';

enum EPaletteKeys {
  GREY = 'grey',
  GREEN = 'green',
  RED = 'red',
  YELLOW = 'yellow',
  PURPLE = 'purple',
  BLUE = 'blue',
  PINK = 'pink',
  ORANGE = 'orange',
  BRAND_ACCENT = 'brandAccent',
  OTHER = 'other',
}

type TPaletteEntries = Record<
  EPaletteKeys,
  [keyof typeof DEFAULT_PALETTE, (typeof DEFAULT_PALETTE)[keyof typeof DEFAULT_PALETTE]][]
>;

const createPaletteEntries = (): TPaletteEntries => {
  const paletteEntries: TPaletteEntries = Object.values(EPaletteKeys).reduce(
    (acc, key) => ({...acc, [key]: []}),
    {} as TPaletteEntries,
  );

  for (const key in DEFAULT_PALETTE) {
    const colorPaletteKey =
      Object.values(EPaletteKeys).find((paletteKey) => key.includes(paletteKey)) ??
      EPaletteKeys.OTHER;

    paletteEntries[colorPaletteKey] = [
      ...paletteEntries[colorPaletteKey],
      [
        key,
        DEFAULT_PALETTE[key as keyof typeof DEFAULT_PALETTE],
      ] as TPaletteEntries[keyof TPaletteEntries][number],
    ];
  }

  return paletteEntries;
};

const ColorPalette = React.memo(() => {
  return (
    <S.ColorPalette>
      <S.Header>Design System Colors</S.Header>
      <S.ColorsGrid>
        {Object.entries(createPaletteEntries()).map(([paletteKey, paletteEntries]) => (
          <S.PaletteColumn key={paletteKey}>
            {paletteEntries.map(([key, value]) => (
              <S.Color color={value} key={key} isFull>
                <S.ColorName>{key}</S.ColorName>
                <S.ColorCode>{value}</S.ColorCode>
              </S.Color>
            ))}
          </S.PaletteColumn>
        ))}
      </S.ColorsGrid>
      <S.Header>Branding Palette</S.Header>
      <S.ColorsGrid>
        {Object.entries(DEFAULT_BRANDING).map(([paletteKey, palette]) => (
          <S.PaletteColumn key={paletteKey}>
            <S.SmallTitle>{paletteKey}</S.SmallTitle>
            {Object.entries(palette).map(([key, value]) => (
              <S.Color color={value} key={key} isFull>
                <S.ColorName>{key}</S.ColorName>
                <S.ColorCode>{value}</S.ColorCode>
              </S.Color>
            ))}
          </S.PaletteColumn>
        ))}
      </S.ColorsGrid>
    </S.ColorPalette>
  );
});

export default ColorPalette;
